<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Rating from '$lib/PageSections/Reviews/Rating.svelte';
	import reviewsJSON from '$lib/PageSections/Reviews/reviews.json';

	let { product, title: titleProp = 'RECOMMENDED FOR YOU' } = $props();
	let { title, price, thumbnail, summary, noise, href } = $derived(product);

	let rating = reviewsJSON?.stats?.company?.average_rating;
</script>

<div
	class="
   mx-auto w-full max-w-3xl rounded-none bg-indow-grey-medium p-5 shadow-md
   sm:mb-8
   md:rounded-xl md:p-8
 "
>
	<h3 class="mb-6 text-3xl text-indow-white">{titleProp}</h3>

	<div
		class="
    mb-8 flex flex-col gap-6
    sm:flex-row
  "
	>
		<div>
			<Image
				src={thumbnail}
				class="
      w-60 rounded-sm
      sm:w-full
    "
			/>
		</div>
		<div>
			<p class="mb-2 text-left text-2xl font-medium text-indow-white uppercase">
				{title}
			</p>
			<div class="mb-2 inline-block">
				<Rating stars="5" {rating} hideMetaData starWidth="1.35rem" />
			</div>
			<p class="text-left text-lg font-thin text-indow-white italic">
				Starting at ${price}/sf
			</p>
			<p class="text-left text-indow-white">{summary}</p>
			<div
				class="
      block
      sm:inline-block
    "
			>
				<Button {href}>SHOP NOW</Button>
			</div>
		</div>
	</div>

	<h3
		class="
    mb-0 rounded-t-xl border-2 border-indow-white bg-indow-white px-6 pt-2 pb-1
    text-lg font-bold text-indow-grey-dark
    sm:text-xl
  "
	>
		Performance Highlights
	</h3>

	<div
		class="
    rounded-b-xl border-3 border-indow-white bg-indow-grey-medium p-3
    sm:p-6
  "
	>
		<ul
			class="
     flex w-full list-none flex-wrap justify-evenly gap-3 gap-y-6
     md:gap-6
   "
		>
			<li class="flex flex-col-reverse gap-3">
				<h4 class="mb-0 pt-0 font-medium text-indow-white">
					ENERGY<br />SAVINGS
				</h4>
				<p
					class="
       rounded-xl bg-indow-white p-3 text-center text-indow-grey-dark
       sm:p-5
     "
				>
					<span class="text-sm font-medium">AVERAGE</span><br />
					<span
						class="
        text-3xl font-bold
        sm:text-4xl
      ">20%</span
					>
				</p>
			</li>
			<li class="flex flex-col-reverse gap-3">
				<h4 class="mb-0 pt-0 font-medium text-indow-white">
					NOISE<br />REDUCTION
				</h4>
				<p
					class="
       rounded-xl bg-indow-white p-3 text-center text-indow-grey-dark
       sm:p-5
     "
				>
					<span class="text-sm font-medium">UP TO</span><br />
					<span
						class="
        text-3xl font-bold
        sm:text-4xl
      ">{noise}%</span
					>
				</p>
			</li>
			<li class="flex flex-col-reverse gap-3">
				<h4 class="mb-0 pt-0 font-medium text-indow-white">
					PERFECT <br />FIT RATE
				</h4>
				<p
					class="
       rounded-xl bg-indow-white p-3 text-center text-indow-grey-dark
       sm:p-5
     "
				>
					<span class="text-sm font-medium">OVER</span><br />
					<span
						class="
        text-3xl font-bold
        sm:text-4xl
      ">99%</span
					>
				</p>
			</li>
		</ul>
	</div>
</div>
